const PhoneCallIcon = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 32 32'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.2'
                d='M11.5625 15.6C12.5915 17.725 14.3098 19.4389 16.4375 20.4625C16.5944 20.5368 16.768 20.569 16.9412 20.5558C17.1143 20.5427 17.2811 20.4846 17.425 20.3875L20.55 18.3C20.6881 18.2063 20.8476 18.1492 21.0137 18.1339C21.1799 18.1186 21.3472 18.1456 21.5 18.2125L27.35 20.725C27.5499 20.8082 27.717 20.9548 27.8254 21.1423C27.9338 21.3298 27.9776 21.5477 27.95 21.7625C27.7646 23.2097 27.0582 24.5397 25.9631 25.5037C24.8679 26.4677 23.459 26.9997 22 27C17.4913 27 13.1673 25.2089 9.97919 22.0208C6.79107 18.8327 5 14.5087 5 9.99998C5.00033 8.54098 5.53227 7.13208 6.49628 6.03692C7.4603 4.94177 8.79033 4.2354 10.2375 4.04998C10.4523 4.02239 10.6702 4.06617 10.8577 4.17459C11.0452 4.28301 11.1918 4.45004 11.275 4.64998L13.7875 10.5125C13.8528 10.6629 13.8802 10.8271 13.8671 10.9906C13.854 11.1541 13.8009 11.3118 13.7125 11.45L11.625 14.625C11.5321 14.7686 11.4775 14.9336 11.4666 15.1043C11.4556 15.275 11.4887 15.4457 11.5625 15.6Z'
                fill='black'
            />
            <path
                d='M11.5625 15.6C12.5915 17.725 14.3098 19.4389 16.4375 20.4625C16.5944 20.5368 16.768 20.569 16.9412 20.5558C17.1143 20.5427 17.2811 20.4846 17.425 20.3875L20.55 18.3C20.6881 18.2063 20.8476 18.1492 21.0137 18.1339C21.1799 18.1186 21.3472 18.1456 21.5 18.2125L27.35 20.725C27.5499 20.8082 27.717 20.9548 27.8254 21.1423C27.9338 21.3298 27.9776 21.5477 27.95 21.7625C27.7646 23.2097 27.0582 24.5397 25.9631 25.5037C24.8679 26.4677 23.459 26.9997 22 27C17.4913 27 13.1673 25.2089 9.97919 22.0208C6.79107 18.8327 5 14.5087 5 9.99998C5.00033 8.54098 5.53227 7.13208 6.49628 6.03692C7.4603 4.94177 8.79033 4.2354 10.2375 4.04998C10.4523 4.02239 10.6702 4.06617 10.8577 4.17459C11.0452 4.28301 11.1918 4.45004 11.275 4.64998L13.7875 10.5125C13.8528 10.6629 13.8802 10.8271 13.8671 10.9906C13.854 11.1541 13.8009 11.3118 13.7125 11.45L11.625 14.625C11.5321 14.7686 11.4775 14.9336 11.4666 15.1043C11.4556 15.275 11.4887 15.4457 11.5625 15.6V15.6Z'
                stroke='black'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M19.925 5C21.6212 5.45522 23.1678 6.34857 24.4096 7.59039C25.6514 8.83221 26.5448 10.3788 27 12.075'
                stroke='black'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M18.8875 8.86249C19.9077 9.13342 20.8381 9.66922 21.5844 10.4156C22.3308 11.1619 22.8666 12.0923 23.1375 13.1125'
                stroke='black'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default PhoneCallIcon;
